import { memo, useCallback, useEffect, useState } from "react";
import { TMessageForm } from "../messagesSchema";
import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { ticketChannelStepsByTicketChannel } from "../../../../../../../services/ticketChannelStep.service";

const translationPath = "page.4uMarCom.automationRules.marcom_message.";

interface ITicketChannelStepMessagesMarcomProps {
  name?: "ticketChannelStep" | "ticketChannelStepWhenNotIdentified";
  ticketChannelFieldName?: "ticketChannel" | "ticketChannelWhenNotIdentified";
}

export const TicketChannelStepMessagesMarcom = memo(
  ({
    name = "ticketChannelStep",
    ticketChannelFieldName = "ticketChannel",
  }: ITicketChannelStepMessagesMarcomProps) => {
  const { t } = useTranslation();

  const { control } = useFormContext<TMessageForm>();

  const { sendRequest } = useFetch(ticketChannelStepsByTicketChannel);

  const [ticketChannelSteps, setTicketChannelSteps] = useState<ISelectType[]>(
    [],
  );

  const ticketChannel = useWatch({
    control,
    name: ticketChannelFieldName,
  });

  const fetchTicketChannelSteps = useCallback(async () => {
    if (!ticketChannel?.id) {
      setTicketChannelSteps([]);
      return;
    }
    const { data, success } = await sendRequest({
      id: ticketChannel.id,
      all: true,
    });
    if (data && success) {
      setTicketChannelSteps(data);
    }
  }, [sendRequest, ticketChannel]);

  useEffect(() => {
    fetchTicketChannelSteps();
  }, [fetchTicketChannelSteps, ticketChannel]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        options={ticketChannelSteps}
        getOptionLabel={({ name }) => name}
        size="small"
        label={t(translationPath + "ticket_channel_step")}
        name={name}
      />
    </Grid>
  );
  },
);
